var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CONFIG } from "../../config/app.config";
import api from "../../utils/api/api.utils";
import { append } from "../../utils/api.utils";
var BASE_PATH = "/templates";
// This module still owns the endpoints reduxV2/template does not cover for its
// consumers — detail, create, update, delete and duplicate — so the calls are pointed at
// v2 here rather than by rewriting every consumer onto the v2 module. isV2 only swaps the
// host and the auth header, so the differences are absorbed below: PUT becomes PATCH,
// every response is unwrapped from its { data } envelope so the generic sagas keep
// destructuring an axios-shaped result, and the list query is translated to the v2 shape.
// v2 pages are 1-based (RENTIO_PAGING_DEFAULT_PAGE=1); the v1 paged saga hands us a row
// offset, so it is converted back into a page number.
var skipToPage = function (skip, limit) {
    return Math.floor(skip / Math.max(limit, 1)) + 1;
};
// v1 sorting is a list of "<field> <DIRECTION>" strings; v2 takes objects.
var orderToSort = function (order) {
    if (!order) {
        return undefined;
    }
    var orders = Array.isArray(order) ? order : [order];
    return orders.map(function (entry) {
        var _a = entry.trim().split(/\s+/), field = _a[0], method = _a[1];
        return {
            field: field,
            method: (method === null || method === void 0 ? void 0 : method.toUpperCase()) === "DESC" ? "DESC" : "ASC",
        };
    });
};
// The comparison operators a field may be filtered on. An operator object is passed
// through rather than translated, so without this the shim would forward any shape it is
// handed — including a nested `and`/`or` that widens the query well beyond the single
// field the caller named. Bounded to comparisons so what reaches v2 stays one predicate
// per field.
var ALLOWED_FILTER_OPERATORS = [
    "between",
    "eq",
    "gt",
    "gte",
    "iLike",
    "in",
    "is",
    "isNot",
    "like",
    "lt",
    "lte",
    "neq",
    "notIn",
];
var isFieldFilter = function (value) {
    return Object.keys(value).every(function (key) {
        return ALLOWED_FILTER_OPERATORS.includes(key);
    });
};
// v1 callers pass a loopback-style `{ where: { field: value } }`; v2 expects a flat
// nestjs-query filter keyed by operator. Plain equality is translated, and a value that
// is already an operator object is passed through once its operators are recognized.
// Richer loopback operators (inq, and/or) are not mapped — no template screen uses them,
// and an unrecognized shape throws rather than being forwarded, so a caller that needs
// one has to map it here instead of silently getting a wider result set.
var toV2Filter = function (filter) {
    var _a;
    var where = ((_a = filter === null || filter === void 0 ? void 0 : filter.where) !== null && _a !== void 0 ? _a : filter);
    if (!where || Object.keys(where).length === 0) {
        return undefined;
    }
    return Object.entries(where).reduce(function (result, _a) {
        var field = _a[0], value = _a[1];
        if (value !== null && typeof value === "object") {
            if (!isFieldFilter(value)) {
                throw new Error("Unsupported template filter for \"".concat(field, "\": only ").concat(ALLOWED_FILTER_OPERATORS.join(", "), " are mapped to v2"));
            }
            result[field] = value;
            return result;
        }
        result[field] = { eq: value };
        return result;
    }, {});
};
export var createTemplate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post(BASE_PATH, {
                    isV2: true,
                    data: params.data,
                })];
            case 1:
                response = (_a.sent()).data;
                return [2 /*return*/, { data: response.data }];
        }
    });
}); };
export var updateTemplate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.patch("".concat(BASE_PATH, "/").concat(params.id), {
                    isV2: true,
                    data: params.data,
                })];
            case 1:
                response = (_a.sent()).data;
                return [2 /*return*/, { data: response.data }];
        }
    });
}); };
export var deleteTemplate = function (params) {
    return api.delete("".concat(BASE_PATH, "/").concat(params.id), { isV2: true });
};
export var getTemplate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("".concat(BASE_PATH, "/").concat(params.id), {
                    isV2: true,
                })];
            case 1:
                response = (_a.sent()).data;
                return [2 /*return*/, { data: response.data }];
        }
    });
}); };
// v1 needed a second call with a wider field set to pick up data/fields/documentIds.
// v2 has no field selection and always returns the complete template, so this is the same
// request as getTemplate and is kept only so its callers stay untouched.
export var getTemplateDetail = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("".concat(BASE_PATH, "/").concat(params.id), {
                    isV2: true,
                })];
            case 1:
                response = (_a.sent()).data;
                return [2 /*return*/, { data: response.data }];
        }
    });
}); };
export var getTemplates = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var skip, _a, limit, _b, order, filter, response;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                skip = params.skip, _a = params.limit, limit = _a === void 0 ? CONFIG.DEFAULT_FETCH_LIMIT : _a, _b = params.order, order = _b === void 0 ? ["createdAt DESC"] : _b, filter = params.filter;
                return [4 /*yield*/, api.get(append(BASE_PATH, {
                        page: skipToPage(skip, limit),
                        limit: limit,
                        sort: orderToSort(order),
                        filter: toV2Filter(filter),
                    }), {
                        isV2: true,
                    })];
            case 1:
                response = (_c.sent()).data;
                // The paged saga expects a bare array, as v1 returned.
                return [2 /*return*/, { data: response.data.items }];
        }
    });
}); };
export var duplicateTemplate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("".concat(BASE_PATH, "/").concat(params.id, "/duplicate"), {
                    isV2: true,
                })];
            case 1:
                response = (_a.sent()).data;
                return [2 /*return*/, { data: response.data }];
        }
    });
}); };
